var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",style:({ backgroundColor: _vm.backgroundColor })},[[_c('img',{staticClass:"tag__image",attrs:{"src":_vm.icon,"alt":"tag icon"}})],_vm._v(" "),[_c('span',{staticClass:"tag__text"},[_vm._v(_vm._s(_vm.text))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }